<ng-container [ngSwitch]="type.name">
  <h2 *ngSwitchCase="'h2'" [innerHTML]="content"></h2>
  <h3 *ngSwitchCase="'h3'" [innerHTML]="content"></h3>
  <h4 *ngSwitchCase="'h4'" [innerHTML]="content"></h4>
</ng-container>
